<mat-nav-list role="navigation" data-testid="app-navigation">
  <mat-list-item *ngIf="showNav('commande')" routerLink="/commande" (click)="toggleMenu()" aria-label="menu de navigation"
                 data-testid="menu-item-commande">
    <mat-icon matListItemIcon>library_books</mat-icon>
    <span matListItemTitle>Les commandes</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item
    *ngIf="accesExecutionBudgetaire()"
    routerLinkActive="active-link"
    routerLink="/budget/gestion-budgetaire"
    (click)="toggleMenu()"
    aria-label="menu de navigation"
    data-testid="menu-item-gestion-budgetaire">
    <mat-icon matListItemIcon>account_balance</mat-icon>
    <span matListItemTitle>Gestion budgétaire</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item
    *ngIf="accesValidationVirement()"
    routerLinkActive="active-link"
    routerLink="/budget/validation-virement/"
    (click)="toggleMenu()"
    data-testid="menu-item-mouvements-financiers">
    <mat-icon matListItemIcon>free_cancellation</mat-icon>
    <span matListItemTitle>Mouvements financiers</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item *ngIf="accesBascule()" routerLinkActive="active-link" routerLink="/bascule" (click)="toggleMenu()" data-testid="menu-item-blocage-saisie">
    <mat-icon matListItemIcon>balance</mat-icon>
    <span matListItemTitle>Actions SAF</span>
  </mat-list-item>

  <mat-divider *ngIf="showNav('marche')"></mat-divider>

  <mat-list-item
    *ngIf="showNav('marche')"
    routerLinkActive="active-link"
    routerLink="/marche"
    (click)="toggleMenu()"
    aria-label="menu de navigation"
    data-testid="menu-item-marche">
    <mat-icon matListItemIcon>gavel</mat-icon>
    <span matListItemTitle>Marché</span>
  </mat-list-item>

  <mat-divider></mat-divider>

  <mat-list-item
    *ngIf="isSAF"
    routerLinkActive="active-link"
    class="parent"
    (click)="showSubMenuAdministration = !showSubMenuAdministration"
    aria-label="menu déroulant pour l'administration"
    data-testid="menu-item-administration">
    <mat-icon matListItemIcon>manage_accounts</mat-icon>
    <span matListItemTitle>Administration</span>
    <span matListItemMeta>
      <mat-icon class="menu-icon-chevron" [ngClass]="{ rotated: showSubMenuAdministration }" aria-label="chevron d'extension de menu">
        expand_more
      </mat-icon>
    </span>
  </mat-list-item>

  <div class="submenu" [ngClass]="{ expanded: showSubMenuAdministration }">
    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/chapitre"
      (click)="toggleMenu()"
      *ngIf="accesChapitre() && showNav('adminChapitree')"
      data-testid="menu-item-chapitres">
      <span matListItemTitle>Chapitres et natures analytiques</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/operation-tranche"
      (click)="toggleMenu()"
      *ngIf="accesOperation() && showNav('adminOperation')"
      data-testid="menu-item-operations">
      <span matListItemTitle>Opérations et tranches</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/nature-depense"
      (click)="toggleMenu()"
      *ngIf="accesNature() && showNav('adminNature')"
      data-testid="menu-item-natures-depenses">
      <span matListItemTitle>Natures dépenses</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/projet"
      (click)="toggleMenu()"
      *ngIf="accesProjet()"
      data-testid="menu-item-projets">
      <span matListItemTitle>Projets</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/import-ligne-budget"
      (click)="toggleMenu()"
      *ngIf="accesImportFichier()"
      data-testid="menu-item-import">
      <span matListItemTitle>Importer un fichier</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/services"
      (click)="toggleMenu()"
      *ngIf="accesService()"
      data-testid="menu-item-services">
      <span matListItemTitle>Services</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/adresses"
      (click)="toggleMenu()"
      *ngIf="accesAdresses()"
      data-testid="menu-item-adresses">
      <span matListItemTitle>Adresses</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/fournisseurs"
      (click)="toggleMenu()"
      *ngIf="accesFournisseurs()"
      data-testid="menu-item-fournisseurs">
      <span matListItemTitle>Fournisseurs</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/support-contractuel"
      (click)="toggleMenu()"
      *ngIf="accesSupportContratuel()"
      data-testid="menu-item-supports-contractuels">
      <span matListItemTitle>Supports contractuels</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/valideur-complementaire"
      (click)="toggleMenu()"
      *ngIf="accesValideurComplementaire()"
      data-testid="menu-item-valideurs-complementaires">
      <span matListItemTitle>Valideurs complémentaires</span>
    </mat-list-item>

    <mat-list-item
      routerLinkActive="active-link"
      routerLink="/administration/pdf"
      (click)="toggleMenu()"
      *ngIf="accesPdf()"
      data-testid="menu-item-textes-pdf">
      <span matListItemTitle>Textes</span>
    </mat-list-item>
  </div>
</mat-nav-list>
